import { DetallCarrer } from './../../pages/detallCarrer/detallCarrer';
import { State } from './../../providers/state';
import { Component, Input } from '@angular/core';
import { NavController } from 'ionic-angular';

import { ModalShare } from './../../components/modal-share/modal-share';

@Component({
  selector: 'carrer-favorits',
  templateUrl: 'carrer-favorits.html'
})
export class CarrerFavoritsComponent {

  public star : boolean = true;
  public estrella: string = "active";
  @Input () id: number;
  @Input () adreca: string;
  @Input () tipo: string;
  @Input () regim: string;
  @Input () urlimg: string;
  @Input () espai: string;
  @Input () location: string;

  constructor(public navCtrl: NavController,public state: State) {

  }

  ionViewWillEnter(){
    this.star = !this.state.comprovaImmobleExistent(this.id);
    this.estrella = (this.star)?"active":"nactive";
  }

  changeBoolean (){
    if(this.star){
      this.state.deleteImmoble(this.id);
    }else{
      this.state.setImmoble(this.id);
    }
    this.star = !this.star;
    this.estrella = (this.star)?"active":"nactive";
  }

    goToDetallCarrer(){
      this.navCtrl.push(DetallCarrer, {
        'OBJECTID': this.id
      });
    }

    openShare(){
      this.navCtrl.push(
        ModalShare, 
        {'OBJECTID': this.id,
        'nomNau': this.adreca
      });
    }

    setSlideWidth(location){
      if((location.Tl_1contac != " " && location.Tl_2contac != " ") && location.E_mail != " "){
        return "petit";
      }else if((location.Tl_1contac != " " && location.Tl_2contac != " ") || location.E_mail != " "){
        return "semi";
      }else{
        return "gros";
      }
    }

}



// WEBPACK FOOTER //
// ./src/components/carrer-favorits/carrer-favorits.ts